import Vue from 'vue';
import store from 'store';
import { isTablet } from 'utils/general';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { trackEvent } from '../../assets/js/lib/tracking';
import { A11y, Keyboard } from 'swiper/modules';

export default (el) =>
  new Vue({
    el,
    store,
    components: {
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
      'lookbook-modal': () => import('../lookbook-modal/lookbook-modal.vue'),
    },
    name: 'Shoppable lookbook',
    data() {
      return {
        familiesNumber: Number(el.dataset.families),
        componentName:
          document.body.dataset.origin + '/' + el.dataset.componentName,
        siteSection: el.dataset.siteSection,
        familyNames: el.dataset.familyNames.split('||'),
        hasNamesCarousel: true,
        isTablet: isTablet(),
        isCarousel: false,
        showModal: false,
        isModalActive: false,
        look: null,
        carouselSwiper: null,
        looksCarouselSwiper: null,
        swiperOptions: {
          slidesPerView: 2.5,
          centeredSlides: true,
          centeredSlidesBounds: true,
          a11y: true,
          keyboard: true,
          loop: true,
          breakpoints: {
            1024: {
              slidesPerView: 4.5
            }
          },
          on: {
            afterInit: (swiper) => {
              this.carouselSwiper = swiper;
            },
          },
          modules: [A11y, Keyboard]
        },
        swiperOptionsLooks: {
          slidesPerView: 1.1,
          loop: true,
          centeredSlides: true,
          centeredSlidesBounds: true,
          a11y: true,
          keyboard: true,
          on: {
            slideChange: (swiper) => {
              if (this.carouselSwiper && swiper.realIndex != this.carouselSwiper.realIndex) {
                this.carouselSwiper.slideToLoop(swiper.realIndex, 300);
              }
            },
            afterInit: (swiper) => {
              this.looksCarouselSwiper = swiper;
            }
          },
          breakpoints: {
            1024: {
              slidesPerView: 1
            }
          },
          modules: [A11y, Keyboard]
        },
      };
    },
    computed: {
      activeFamilyIndex() {
        if (this.carouselSwiper) {
          return this.carouselSwiper.realIndex;
        }

        return 0;
      }
    },
    watch: {
      activeFamilyIndex() {
        if (this.looksCarouselSwiper && this.looksCarouselSwiper.realIndex != this.activeFamilyIndex) {
          this.looksCarouselSwiper.slideToLoop(this.activeFamilyIndex);
        }
      }
    },
    mounted() {
      on(window, 'resize', debounce(this.onResize, 300));
      this.$on('close-modal', this.closeModal());
    },
    methods: {
      onResize() {
        if (this.isTablet !== isTablet()) {
          this.closeModal();
        }
        this.isTablet = isTablet();
      },
      setActiveFamily(index) {
        this.looksCarouselSwiper.slideToLoop(index)

        trackEvent({
          event: 'slider_interactions',
          click_action: 'select',
          section_name: this.familyNames[index],
          component_name: this.componentName,
          image_index: `${index + 1}`,
          ...(this.siteSection && { site_section: this.siteSection }),
        });
      },
      setPrevFamily() {
        this.looksCarouselSwiper.slidePrev(300);
      },
      setNextFamily() {
        this.looksCarouselSwiper.slideNext(300);
      },
      openLookbookModal(index, event) {
        const el = event.target.closest('.shoppable-lookbook__look');
        const data = JSON.parse(el.getAttribute('data-look-json'));
        this.look = data?.[index];

        if (!this.look.content && !this.look.video_link && !this.look.products)
          return;

        trackEvent({
          event: 'slider_interactions',
          click_action: 'image_click',
          component_name: this.componentName,
          image_index: `${index + 1}`,
          ...(this.siteSection && { site_section: this.siteSection }),
        });

        this.showModal = true;
        setTimeout(() => {
          this.isModalActive = true;
          document.body.classList.add('scroll-lock', 'lookbook-open');
        }, 800);
      },
      closeModal() {
        this.isModalActive = false;
        clearAllBodyScrollLocks();
        document.body.classList.remove('scroll-lock', 'lookbook-open');
        setTimeout(() => {
          this.showModal = false;
        }, 300);
      },
    },
  });
